export default __webpack_public_path__ + "static/media/Apollo-light.1d1d7dd5.gif";